export default __webpack_public_path__ + "static/media/coverimage.01b7edff.JPG";